const ROLE = {
    ADMIN : "ADMIN",
    GENERAL : "GENERAL",
    SALESMAN :"SALESMAN"
}

export default ROLE